import React, {useState, useEffect} from 'react';
import { fetchStats, deleteData } from '../../api/api.js';
import Table from './Table.js';
import Notification from './Notification.js';

const Stats = ({user}) => {
    const [clusters, setClusters] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        (async () => {
          const result = await fetchStats();
          setLoading(false);
          setClusters(result);
        })();
    }, []);

    const handleReset = async () => {
        setLoading(true);
        await deleteData();
        const result = await fetchStats();
        setLoading(false);
        setClusters(result);
    }

    return (
        <div className="container">
            {loading ? <section className="section has-text-centered"><div className="lds-dual-ring"></div></section> : (
                <div>
                    {clusters.length ? (
                        <section className="section">
                            <section className="section has-text-centered">
                                <div className="columns is-centered">
                                    <Table { ...{ clusters, user } } />
                                </div>
                            </section>
                            <div className="has-text-centered">
                                <button className="button is-white has-text-danger" onClick={handleReset}>
                                    <span className="icon">
                                        <i className="fas fa-trash" aria-hidden="true"></i>
                                    </span>
                                    <span>Obriši statistiku</span>
                                </button>
                            </div>
                        </section>
                    ):(
                        <Notification />
                    )}
                </div>
            )}
        </div>
    )
}

export default Stats;
